const column = state => state.column
const columns = state => state.columns

export default {
  column,
  columns
}
